/**
 * Intercepta globalmente todas as chamadas fetch.
 * Quando qualquer resposta retorna 401, dispara o evento 'auth:expired'
 * para que o App.js exiba o modal de sessão expirada.
 *
 * 403 (Forbidden) NÃO é interceptado aqui, pois indica permissão insuficiente
 * (ex: nível de usuário baixo), e não sessão expirada.
 *
 * Não intercepta rotas de autenticação (/api/auth/*) para não confundir
 * erros de credenciais inválidas com expiração de token.
 */
export function setupFetchInterceptor() {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    if (response.status === 401) {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';
      const isAuthRoute = url.includes('/api/auth/');

      if (!isAuthRoute) {
        window.dispatchEvent(new CustomEvent('auth:expired'));
      }
    }

    return response;
  };
}
